import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'eiq-grid-side-filter',
  templateUrl: 'grid-side-filter.component.html',
  styleUrls: ['./grid-side-filter.component.scss']
})
export class GridSideFilterComponent {
  @Input() opened: boolean;
  @Output() backdropClick = new EventEmitter<void>();
}
